import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { DonneesAppSettings } from './DonneesAppSettings';

//Service d’accès à la configuration de l’application
@Injectable(
  {
    providedIn: 'root',
  })
export class ValAppSettingsService {
  //Création
  //  Paramètres
  //    httpClient : Client HTTP
  constructor(private httpClient: HttpClient) {
  }

  //Chemin du fichier de configuration
  // Le paramètre ?v= est évalué au chargement de la page (pas à la compilation) pour forcer le rechargement
  // même si le container Docker est relancé avec un nouveau appsettings.json sans reconstruire l'image.
  private readonly configurationUrl = `assets/configuration/appsettings.json?v=${Date.now()}`;

  //Données de configuration (observable)
  private configuration$!: Observable<DonneesAppSettings>;

  //Données de configuration
  private configuration?: DonneesAppSettings;

  //Charge la configuration
  //  Retourne
  //    Données de configuration
  public ChargerConfiguration(): Promise<DonneesAppSettings> {
    if (!this.configuration$) {
      this.configuration$ = this.httpClient.get<DonneesAppSettings>(this.configurationUrl).pipe(shareReplay(1));
    }

    return firstValueFrom(this.configuration$);
  }

  //Configuration
  public get Configuration(): DonneesAppSettings {
    return this.configuration as DonneesAppSettings;
  }

  //Configuration
  public set Configuration(valeur: DonneesAppSettings) {
    this.configuration = valeur;
  }
}

//Charge la configuration
//  Paramètres
//    appSettingsService : Service d’accès à la configuration de l’application
export function ChargerConfiguration(appSettingsService: ValAppSettingsService) {
  return () => appSettingsService.ChargerConfiguration().then((cfg) => {
    appSettingsService.Configuration = cfg;
  });
}
